import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import { HomeOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

const { Sider } = Layout;

const Sidebar = ({ services, selectedService, onServiceSelect, onHomeClick }) => {
  const [collapsed, setCollapsed] = useState(false);

  const handleMenuClick = (e) => {
    if (e.key === 'home') {
      onHomeClick();
    } else {
      const service = services.find(s => s.id === e.key);
      if (service && service.available) {
        onServiceSelect(service);
      }
    }
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Sider 
      width={200} 
      style={{ background: '#fff', display: 'flex', flexDirection: 'column' }}
      breakpoint="lg"
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      trigger={null}
    >
      <Menu
        mode="inline"
        selectedKeys={[selectedService ? selectedService.id : 'home']}
        style={{ flex: 1, borderRight: 0, height: 'calc(100vh - 120px)' }}
        onClick={handleMenuClick}
      >
        <Menu.Item key="home" icon={<HomeOutlined />}>
          Home
        </Menu.Item>
        <Menu.ItemGroup key="services" title={!collapsed && "Services"}>
          {services.map(service => (
            <Menu.Item 
              key={service.id} 
              disabled={!service.available}
              title={service.name + (!service.available ? ' (Coming Soon)' : '')}
              icon={
                <div className="sidebar-service-logo">
                  <img src={service.logo} alt={service.name} />
                </div>
              }
            >
              {!collapsed && service.name} {!collapsed && !service.available && '(Coming Soon)'}
            </Menu.Item>
          ))}
        </Menu.ItemGroup>
      </Menu>
      <div className="sidebar-trigger" onClick={toggleCollapsed}>
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </div>
    </Sider>
  );
};

export default Sidebar; 